/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface AddNoteRequest
 */
export interface AddNoteRequest {
  /**
   *
   * @type {string}
   * @memberof AddNoteRequest
   */
  applicationId: string;
  /**
   *
   * @type {string}
   * @memberof AddNoteRequest
   */
  body: string;
}

/**
 * Check if a given object implements the AddNoteRequest interface.
 */
export function instanceOfAddNoteRequest(
  value: object,
): value is AddNoteRequest {
  if (!("applicationId" in value) || value["applicationId"] === undefined)
    return false;
  if (!("body" in value) || value["body"] === undefined) return false;
  return true;
}

export function AddNoteRequestFromJSON(json: any): AddNoteRequest {
  return AddNoteRequestFromJSONTyped(json, false);
}

export function AddNoteRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): AddNoteRequest {
  if (json == null) {
    return json;
  }
  return {
    applicationId: json["applicationId"],
    body: json["body"],
  };
}

export function AddNoteRequestToJSON(json: any): AddNoteRequest {
  return AddNoteRequestToJSONTyped(json, false);
}

export function AddNoteRequestToJSONTyped(
  value?: AddNoteRequest | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    applicationId: value["applicationId"],
    body: value["body"],
  };
}
